import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'aos/dist/aos.css';
import AOS from 'aos';

// Clear the previous-session viewMode pick on every page load so the
// DualView splash chooser re-appears on refresh. In-app navigation
// (e.g. clicking About and coming back) still preserves the choice
// because localStorage gets written when the visitor commits — it's
// only this initial-load wipe that resets it. Also strips any
// `?view=` URL param so a refresh of `/?view=dev` still shows the
// splash. Runs synchronously before React mounts so the first render
// already sees an empty viewMode.
try {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('viewMode');
    const url = new URL(window.location.href);
    if (url.searchParams.has('view')) {
      url.searchParams.delete('view');
      window.history.replaceState({}, '', url.toString());
    }
  }
} catch (e) {
  // localStorage / URL access may throw in sandboxed contexts — fine
  // to silently no-op; the splash will just always show.
}

AOS.init({ once: true, duration: 700, easing: 'ease-out-cubic' });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
